import api from './api'

const loadUF = async (params) => {
  const response = await api.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados', { params })
  return response.data.sort((a, b) => a.nome.localeCompare(b.nome))
}

export const IBGEService = {
  loadUF,
}
